import React from "react";

import BaseModal from "@/components/Modals/BaseModal";
import Button from "@/components/Button";

import { ActionsModalInterface } from "../Modal.interface";

import styles from "./ActionsModal.module.scss";

export const ActionsModal: React.FC<ActionsModalInterface> = ({
  children,
  confirmActionHandler,
  confirmActionLabel,
  cancelActionLabel,
  onClose,
  isOpen,
}) => (
  <BaseModal isOpen={isOpen} onClose={onClose}>
    <div className={styles.children}>{children}</div>

    <div className={styles.actions}>
      <Button variant="secondary" onClick={onClose}>
        {cancelActionLabel}
      </Button>

      <Button variant="primary" onClick={confirmActionHandler}>
        {confirmActionLabel}
      </Button>
    </div>
  </BaseModal>
);

export default ActionsModal;
